import { type Dayjs } from '@funnellab/shared/src/utils/dayjs.ts';
import { type TransformerFn } from '@components/input/TextInput.tsx';
// eslint-disable-next-line no-restricted-imports
import dayjs_org from 'dayjs';

export const DayjsTransformer: TransformerFn<Dayjs> = (input) =>
  dayjs_org(new Date(input));

export const formatDate = (input?: Dayjs): string =>
  input?.toISOString().split('T')[0] ?? '';

export const formatDateTime = (input?: Dayjs): string =>
  input?.format('YYYY-MM-DDTHH:mm') ?? '';

// This style will show a blue ring around the focused element, but only when using keyboard input
export const focusStyle =
  'has-[:focus-visible]:outline-none has-[:focus-visible]:ring has-[:focus-visible]:ring-blue-500 has-[:focus-visible]:ring-offset-1';
